package com.devi3east.bashbuddy.features.common.util

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.text.input.VisualTransformation
import androidx.compose.ui.unit.dp
import kotlinx.datetime.*

@Composable
fun DateTimeInput(
    instant: Instant?,
    onDateTimeChange: (Instant) -> Unit
) {
    val timeZone = TimeZone.currentSystemDefault()
    val cardShape = RoundedCornerShape(12.dp)

    var showDatePicker by remember { mutableStateOf(false) }
    var showTimePicker by remember { mutableStateOf(false) }

    val displayDate = DateTimeFormatUtil.instantToDateString(instant)
    val displayTime = DateTimeFormatUtil.instantToTimeString(instant)

    Row(
        modifier = Modifier.fillMaxWidth(),
        horizontalArrangement = Arrangement.spacedBy(8.dp)
    ) {

        // ---------- DATE FIELD ----------
        Box(
            modifier = Modifier
                .weight(1f)
                .clip(cardShape)
                .clickable { showDatePicker = true }
        ) {
            OutlinedTextField(
                value = displayDate,
                onValueChange = {},
                label = { Text("Date") },
                readOnly = true,
                enabled = false,
                singleLine = true,
                modifier = Modifier.fillMaxWidth(),
                shape = cardShape,
                colors = OutlinedTextFieldDefaults.colors(
                    disabledTextColor = MaterialTheme.colorScheme.onSurface,
                    disabledBorderColor = MaterialTheme.colorScheme.outline
                ),
                visualTransformation = VisualTransformation.None
            )
        }

        // ---------- TIME FIELD ----------
        Box(
            modifier = Modifier
                .weight(1f)
                .clip(cardShape)
                .clickable { showTimePicker = true }
        ) {
            OutlinedTextField(
                value = displayTime,
                onValueChange = {},
                label = { Text("Time") },
                readOnly = true,
                enabled = false,
                singleLine = true,
                modifier = Modifier.fillMaxWidth(),
                shape = cardShape,
                colors = OutlinedTextFieldDefaults.colors(
                    disabledTextColor = MaterialTheme.colorScheme.onSurface,
                    disabledBorderColor = MaterialTheme.colorScheme.outline
                ),
                visualTransformation = VisualTransformation.None
            )
        }
    }

    // ---------- DATE PICKER ----------
    if (showDatePicker) {
        ModernCalendarPicker(
            initialInstant = instant,
            onDateSelected = { selectedInstant ->
                val current = instant?.toLocalDateTime(timeZone)
                    ?: Clock.System.now().toLocalDateTime(timeZone)

                val newDate = LocalDate.fromEpochDays(
                    (selectedInstant.toEpochMilliseconds() / DAY_MS).toInt()
                )

                val combined = LocalDateTime(
                    date = newDate,
                    time = current.time
                ).toInstant(timeZone)

                onDateTimeChange(combined)
                showDatePicker = false
            },
            onDismiss = { showDatePicker = false }
        )
    }

    // ---------- TIME PICKER ----------
    if (showTimePicker) {
        ModernTimePicker(
            initialInstant = instant,
            onTimeSelected = { selectedInstant ->
                val current = instant?.toLocalDateTime(timeZone)
                    ?: Clock.System.now().toLocalDateTime(timeZone)

                val newTime = selectedInstant
                    .toLocalDateTime(timeZone)
                    .time

                val combined = LocalDateTime(
                    date = current.date,
                    time = newTime
                ).toInstant(timeZone)

                onDateTimeChange(combined)
                showTimePicker = false
            },
            onDismiss = { showTimePicker = false }
        )
    }
}